import { useContext } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { Evaluation } from 'redux/schemas/models/ai-role-play';
import NvSubmissionFeedbackCard from 'shared/components/submission/nv-submission-feedback-card';
import { gray4, gray7 } from 'styles/global_defaults/colors';
import { RootState } from 'redux/schemas';
import { getAiRolePlaySubmission } from 'redux/selectors/timeline';
import { AngularContext } from 'react-app';
import SubmissionEvaluationStatus from './submission-evaluation-status';

type RolePlaySubmissionCardProps = {
  submissionId: number;
};

const RolePlaySubmissionCard = (props: RolePlaySubmissionCardProps) => {
  const { submissionId } = props;
  const submission = useSelector((state: RootState) => getAiRolePlaySubmission(state, submissionId));
  const { feedback } = submission || {};
  const { evaluation, overallSummary } = feedback || {};

  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);

  if (!submission || !submission.user) return null;

  const getHeaderBackgroundColor = () => {
    switch (evaluation) {
      case Evaluation.NEED_WORK:
        return '#FFEFE2';
      case Evaluation.GOOD_JOB:
        return '#DBF3F5';
      case Evaluation.EXCELLENT:
        return '#E2F2DF';
      default:
        return gray7;
    }
  };

  const getHeaderBorderColor = () => {
    switch (evaluation) {
      case Evaluation.NEED_WORK:
        return '#D07B5F';
      case Evaluation.GOOD_JOB:
        return '#78B1C8';
      case Evaluation.EXCELLENT:
        return '#66977B';
      default:
        return gray4;
    }
  };

  const handleViewFeedback = () => {
    $state.go('role-play-submission-modal', {
      rolePlayId: submission.aiRolePlay.id,
      section: submission.id,
      fromGallery: true,
      filter: $state.params.filter,
      search: $state.params.search,
    });
  };

  return (
    <NvSubmissionFeedbackCard
      title={submission.user.fullName}
      description={overallSummary || t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.EMPTY_FEEDBACK()}
      headerBackgroundColor={getHeaderBackgroundColor()}
      headerBorderColor={getHeaderBorderColor()}
      status={<SubmissionEvaluationStatus evaluation={evaluation} />}
      user={submission.user}
      onClick={handleViewFeedback}
    />
  );
};

export default RolePlaySubmissionCard;
